export default __webpack_public_path__ + "static/media/av3crv.34f9360a.svg";